<template>
    <div class="">

        <a class="list-group-item" href="#" @click="show_list = !show_list">
            <i class="fas fa-angle-right fa-fw"></i>{{group_name}}
        </a>
        <div v-if="show_list" class="list-group">

            <li
                is="AccountButton"
                v-for="(acc, index) in filteredAccounts"
                v-bind:key="acc.id"
                v-bind:index="index"
                v-bind:name=acc.name
            ></li>

        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import AccountButton from '../AccountButton.vue'
Vue.use(AccountButton)

export default {
    name: 'GroupList',
    props: {
        group_name: String,
        accounts: []
    },
    components: {
        AccountButton
    },
    data() {
        return {
            show_list: true
        }
    },
    computed: {
        filteredAccounts() {
            return this.accounts.filter(function (acc) {
                return !(acc.name.endsWith("_INCOME") || acc.name.endsWith("_EXPENSE"));
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
